import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class DeleteSubmittalEffect {
    deleteSubmittal$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.deleteSubmittal),
            switchMap((action) => {
                return this.liveNursesService
                    .deleteSubmittal(
                        action.submittalId,
                        action.reason,
                        action.submittalStatusId,
                        action.submittalSubStatusId
                    )
                    .pipe(
                        map(() => actions.deleteSubmittalSuccess({ submittalId: action.submittalId })),
                        catchError((error) => of(actions.deleteSubmittalFail({ error })))
                    );
            })
        )
    );

    deleteSubmittalFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.deleteSubmittalFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while deleting a submittal.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private readonly actions$: Actions,
        protected readonly liveNursesService: LiveNursesService,
        private readonly toaster: ToasterService
    ) {}
}
